import { render, staticRenderFns } from "./AnimateBox.vue?vue&type=template&id=72a4b71c&scoped=true"
import script from "./AnimateBox.vue?vue&type=script&lang=js"
export * from "./AnimateBox.vue?vue&type=script&lang=js"
import style0 from "./AnimateBox.vue?vue&type=style&index=0&id=72a4b71c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4b71c",
  null
  
)

export default component.exports